import ProjectAtlas from './ProjectAtlas';

const visuals = [
  { matches: ['openshift'], src: '/projects/openshift-operations.webp', position: 'center' },
  { matches: ['terraform', 'azure'], src: '/projects/terraform-azure.webp', position: 'center' },
  { matches: ['automation', 'ci/cd', 'gitops'], src: '/projects/automation-pipeline.webp', position: 'center' },
  { matches: ['kubernetes'], src: '/projects/kubernetes-platform.webp', position: 'center' },
];

function visualFor(project) {
  const searchable = `${project.title || ''} ${(project.tags || []).join(' ')}`.toLowerCase();
  return visuals.find((visual) => visual.matches.some((term) => searchable.includes(term))) || null;
}

export default function ProjectVisual({ project, modal = false }) {
  const visual = visualFor(project);

  if (!visual) return <ProjectAtlas project={project} />;

  return (
    <div
      className={`project-visual${modal ? ' project-visual-modal' : ''}`}
      aria-hidden="true"
    >
      <div className="project-visual-frame">
        <img src={visual.src} alt="" loading={modal ? 'eager' : 'lazy'} decoding="async" style={{ objectPosition: visual.position }} />
        <span className="project-visual-grid" />
        <span className="project-visual-light" />
      </div>
    </div>
  );
}
